var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: _vm.scrollable,
        "max-height": _vm.maxHeight,
        "max-width":
          _vm.$vuetify.breakpoint.name == "xs" ||
          _vm.$vuetify.breakpoint.name == "sm"
            ? "90%"
            : _vm.maxWidth,
        "hide-overlay": _vm.hideOverlay,
        persistent: _vm.persistent,
      },
      scopedSlots: _vm._u(
        [
          _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
            return {
              key: slot,
              fn: function (scope) {
                return [_vm._t(slot, null, null, scope)]
              },
            }
          }),
        ],
        null,
        true
      ),
      model: {
        value: _setup.dialog,
        callback: function ($$v) {
          _setup.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [_vm._t("body")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }